export default "__VITE_ASSET__b5c18c4d__"